import { createFileRoute } from "@tanstack/react-router"
import { parsePersonalityAspectId } from "@/entities/personality"
import { ProfilePersonalitySharePage } from "@/pages/profile/personality-share"

export const Route = createFileRoute(
	"/_authenticated/profile/personality-share",
)({
	component: ProfilePersonalitySharePageWrapper,
	validateSearch: (search) => ({
		aspect: parsePersonalityAspectId(search.aspect, "archetype"),
	}),
})

function ProfilePersonalitySharePageWrapper() {
	const { aspect } = Route.useSearch()
	return <ProfilePersonalitySharePage aspect={aspect} />
}
